import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-azione-revocatoria-view',
  templateUrl: './form-azione-revocatoria-view.component.html',
  styleUrls: ['./form-azione-revocatoria-view.component.css']
})
export class FormAzioneRevocatoriaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
